/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyListModel } from '../../models/key-list-model';
import { RelationshipTypeKeyValueModel } from '../../models/relationship-type-key-value-model';

export interface MasterDataRelationshipTypeLookupByKeyPost$Params {
      body?: KeyListModel
}

export function masterDataRelationshipTypeLookupByKeyPost(http: HttpClient, rootUrl: string, params?: MasterDataRelationshipTypeLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataRelationshipTypeLookupByKeyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<RelationshipTypeKeyValueModel>>;
    })
  );
}

masterDataRelationshipTypeLookupByKeyPost.PATH = '/MasterData/RelationshipTypeLookupByKey';
